<div
  class="scaffold-table-holder"
  [ngClass]="{ 'contrast-table': item?.use_contrast_background }"
>
  <div
    class="top-row-controls-container"
    *ngIf="!isLoading && (!item.avoid_paginating || item.allow_search)"
  >
    <scaffold-search-bar
      *ngIf="item.allow_search && !isLoading"
      [forceOnlyActive]="item?.force_only_active_items"
      [displayActiveStateFilter]="item?.display_active_state_filter"
      [allowSearch]="item.allow_search"
      [hideTermSelect]="item.hide_terms"
      (search)="search($event)"
      [searchData]="searchTerms"
    >
    </scaffold-search-bar>

    <scaffold-paginate-page-select
      *ngIf="!item?.avoid_paginating && !isLoading"
      (perPageChange)="setPageCount($event)"
      [perPageOptions]="item?.pageCounts"
      [(perPage)]="perPage"
      [countLabel]="getCountLabel()"
    ></scaffold-paginate-page-select>
  </div>
  <ng-container *ngIf="itemCount == 0; else mainview"
    ><div class="no-table-result-container" *ngIf="!isLoading">
      <label *ngIf="item"
        >{{
          "no"
            | translation
            | translationFromString
            | transformText : "capitalize"
        }}
        {{ item?.list_view || "data" | translation | titlecase }}
        {{ "to_display" | translation | transformText : "capitalize" }}</label
      >
    </div>
  </ng-container>
  <ng-template #mainview>
    <div *ngIf="item.data_source === 'list'">
      <scaffold-toggle-slide
        status="info"
        [(ngModel)]="item.showTotals"
        *ngIf="item.allow_counts"
      >
        {{ "show_column_totals" | translation }}
      </scaffold-toggle-slide>
      <app-table
        [rowMaxHeight]="'100%'"
        [useVirutalScroll]="false"
        [sortAsc]="sortAsc"
        [tableLayout]="'fixed'"
        [isProcessing]="isProcessing"
        [isLoading]="isLoading"
        [clickableRows]="!!item?.row_link"
        [columns]="filteredColumns"
        [rows]="rows"
        [itemCount]="itemCount"
        [perPage]="perPage"
        (sortChange)="sortTable($event)"
        (clickedRow)="openLinkRow($event)"
        [sortBy]="orderBy"
        [actions]="tableActions"
        (scaffoldLinkClicked)="scaffoldLinkClicked($event)"
        (actionClicked)="actionClicked($event)"
        [activeRoute]="activatedRoute"
      ></app-table>

      <p *ngIf="item.search_load && !view?.length" style="padding: 0 20px">
        {{ "items_no_search_made_yet" | translation }}.
      </p>
      <div>
        <scaffold-paginator
          *ngIf="!item?.avoid_paginating && !isLoading"
          [itemCount]="itemCount"
          [(activePage)]="active"
          [perPage]="perPage"
        >
        </scaffold-paginator>
      </div>
    </div>
    <div *ngIf="item.data_source !== 'list'"></div>
  </ng-template>
</div>
